export default {
  state: () => ({
    champs: []
  }),
  getters: {
    champs: (state) => {
      return state.champs
    }
  },
  mutations: {
    SET_CHAMPS(state, champs) {
      state.champs = champs
    }
  }
}